import React from 'react';
import { Ps2MemoryCardIcon, Ps2ControllerIcon } from './Icons';

/**
 * PS2-era cover maps for popular PS2 titles.
 * Renders stylized PS2 8MB Memory Card save file artwork cards.
 */
const ICONIC_PS2_IMAGES = {
  'SLUS_210.16': {
    banner: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=300&q=80',
    tag: '25 TO LIFE',
    color: '#0284c7',
  },
  'SLUS_208.38': {
    banner: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=300&q=80',
    tag: 'ALL-STAR',
    color: '#16a34a',
  },
  'SCUS_972.58': {
    banner: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=300&q=80',
    tag: 'AMPLITUDE',
    color: '#a855f7',
  },
  'SLUS_205.95': {
    banner: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b675?auto=format&fit=crop&w=300&q=80',
    tag: 'AREA 51',
    color: '#dc2626',
  },
  'SLUS_211.65': {
    banner: 'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?auto=format&fit=crop&w=300&q=80',
    tag: 'ARC LADD',
    color: '#eab308',
  },
  'SLUS_207.25': {
    banner: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?auto=format&fit=crop&w=300&q=80',
    tag: 'BURNOUT 3',
    color: '#f97316',
  },
  'SCUS_972.75': {
    banner: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=300&q=80',
    tag: 'HOT SHOTS',
    color: '#10b981',
  },
  'SCUS_972.68': {
    banner: 'https://images.unsplash.com/photo-1511919884226-fd3cad34687c?auto=format&fit=crop&w=300&q=80',
    tag: 'GT4 BETA',
    color: '#3b82f6',
  },
  'SCUS_971.34': {
    banner: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=300&q=80',
    tag: 'SOCOM II',
    color: '#0284c7',
  },
  'SCUS_974.29': {
    banner: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=300&q=80',
    tag: 'SOCOM 3',
    color: '#0369a1',
  },
};

export default function Ps2GameBadge({ gameId, gameName }) {
  const match = ICONIC_PS2_IMAGES[gameId] || ICONIC_PS2_IMAGES[gameId?.toLowerCase()];

  return (
    <div className="relative group/box shrink-0 select-none">
      {/* PS2 3D Memory Card Case Wrapper */}
      <div
        className="w-10 h-10 md:w-11 md:h-11 rounded-lg border flex flex-col justify-between overflow-hidden relative shadow-md transition-all duration-300 group-hover/box:scale-105"
        style={{
          background: match
            ? `linear-gradient(135deg, ${match.color}33, #090d16)`
            : 'linear-gradient(135deg, rgba(6,182,212,0.15), rgba(15,23,42,0.9))',
          borderColor: match ? match.color : 'rgba(6,182,212,0.3)',
        }}
      >
        {/* PS2 Top Black Header Bar */}
        <div className="bg-black/90 px-1 py-0.5 flex items-center justify-between border-b border-white/10">
          <span className="text-[7px] font-mono font-black text-cyan-400 tracking-tighter uppercase">
            PS2
          </span>
          <span className="text-[6px] font-mono text-white/40">
            8MB
          </span>
        </div>

        {/* Center Cover Art / Icon */}
        <div className="flex-1 flex items-center justify-center relative overflow-hidden bg-black/40">
          {match ? (
            <img
              src={match.banner}
              alt={gameName}
              className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover/box:opacity-90 transition-opacity"
            />
          ) : (
            <div className="text-cyan-400/80 group-hover/box:text-cyan-300 transition-colors">
              <Ps2MemoryCardIcon className="w-5 h-5" />
            </div>
          )}
        </div>

        {/* Bottom Tag Bar */}
        <div className="bg-black/85 px-1 py-0.5 text-[6px] font-mono text-cyan-200 truncate text-center font-bold">
          {match ? match.tag : 'SAVE DATA'}
        </div>
      </div>
    </div>
  );
}
